/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IParticipantsOf,
  IParticipantsOfInterface,
} from "../IParticipantsOf";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "raceId",
        type: "uint256",
      },
    ],
    name: "participantsOf",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IParticipantsOf__factory {
  static readonly abi = _abi;
  static createInterface(): IParticipantsOfInterface {
    return new utils.Interface(_abi) as IParticipantsOfInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IParticipantsOf {
    return new Contract(address, _abi, signerOrProvider) as IParticipantsOf;
  }
}
